(function() {
  let lastRun = 0;
  const delay = 150; // ms to throttle re-run frequency

  function formatVariantLabels() {
    document.querySelectorAll('.chevalnova-varient label').forEach(label => {
      if (label.querySelector('.label-price')) return;

      // Get visible text only (ignore accessibility text)
      const visibleText = Array.from(label.childNodes)
        .filter(node => node.nodeType === Node.TEXT_NODE || (node.nodeType === Node.ELEMENT_NODE && !node.classList?.contains('visually-hidden')))
        .map(node => node.textContent.trim())
        .join(' ')
        .trim();

      const priceMatch = visibleText.match(/(\d{1,2}[.,]\d{1,2}€\/kg)/);
      if (priceMatch) {
        const price = priceMatch[0];
        const mainText = visibleText.replace(price, '').trim();
        label.innerHTML = `
          <span class="label-main-text">${mainText}</span>
          <span class="label-price">${price}</span>
        `;
      }
    });
  }

  // Run initially
  document.addEventListener('DOMContentLoaded', formatVariantLabels);

  // Global observer — catches *any* DOM change on the page
  const observer = new MutationObserver(() => {
    const now = Date.now();
    if (now - lastRun > delay) {
      lastRun = now;
      formatVariantLabels();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

 $(document).on('click', '.ingredient-icon', function () {
        $(this).closest('.flip_box').toggleClass('flipped');
    });



    // ============================================
// PERSISTENT CART DRAWER QUANTITY LIMIT (for "Sac" products, message visible 2s)
// ============================================
(function () {
  const maxQty = 10;
  let observer = null;

  // ---- Core logic ----
  function enforceLimit() {
    const qtyInputs = document.querySelectorAll('.cart-item input.quantity__input');

    qtyInputs.forEach((input) => {
      if (input.dataset.limited === 'true') return;
      input.dataset.limited = 'true';

      input.addEventListener('input', () => checkQuantity(input));
      input.addEventListener('change', () => checkQuantity(input));
    });
  }

  // ---- Check + restrict ----
  function checkQuantity(input) {
    const cartItem = input.closest('.cart-item');
    const value = parseInt(input.value) || 1;

    const title = cartItem?.querySelector('.cart-item__name')?.innerText.toLowerCase() || '';
    const details = cartItem?.innerText.toLowerCase() || '';
    const isBag = title.includes('sac') || details.includes('conditionnement : sac');

    if (!isBag) return; // Skip pallets etc.

    if (value > maxQty) {
      input.value = maxQty;
      showLimitMessage();
    }
  }

  // ---- Message display (append AFTER form#CartDrawer-Form for 2s) ----
  function showLimitMessage() {
    const form = document.querySelector('form#CartDrawer-Form');
    if (!form) return;

    let msg = form.parentElement.querySelector('.quantity-limit-message');
    if (!msg) {
      msg = document.createElement('div');
      msg.className = 'quantity-limit-message';
      msg.style.cssText =
        'color:#d0021b; font-size:14px; margin-top:10px; text-align:center; transition: opacity 0.4s ease;';
      msg.textContent =
        'Maximum 10 individual bags allowed. For larger orders, please select a pallet (10, 20, or 40 bags).';
      form.insertAdjacentElement('afterend', msg);
    }

    // ✅ Show message (reset opacity if hidden before)
    msg.style.opacity = '1';
    msg.style.display = 'block';

    // ✅ Hide after 2 seconds
    clearTimeout(msg.hideTimeout);
    msg.hideTimeout = setTimeout(() => {
      msg.style.opacity = '0';
      setTimeout(() => (msg.style.display = 'none'), 400);
    }, 2000);
  }

  // ---- Observe drawer for DOM changes ----
  function observeCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    if (observer) observer.disconnect();
    observer = new MutationObserver(() => enforceLimit());
    observer.observe(drawer, { childList: true, subtree: true });
  }

  // ---- Initialize ----
  document.addEventListener('DOMContentLoaded', () => {
    observeCartDrawer();
    enforceLimit();
  });
})();
